import {
  PROFILE_DETAIL, PROFILE_DETAIL_FAILURE, PROFILE_DETAIL_SUCCESS,
  PROFILE_EDIT, PROFILE_EDIT_FAILURE, PROFILE_EDIT_SUCCESS,
  PROFILE_UPDATE, PROFILE_UPDATE_FAILURE, PROFILE_UPDATE_SUCCESS,
  PROFILE_IMAGE_UPLOAD, PROFILE_IMAGE_UPLOAD_FAILURE, PROFILE_IMAGE_UPLOAD_SUCCESS
} from './mutation-types'

export default {
  state: {
    profile: null,
    uploadSuccess: false,
    uploadError: false
  },
  getters: {
    profileDetail: state => {
      return state.profile
    },
    imageUploadSuccess: state => {
      return state.uploadSuccess
    },
    imageUploadError: state => {
      return state.uploadError
    }
  },
  actions: {
    [PROFILE_DETAIL] ({dispatch, state, commit}, params) {
      var url = '/asovi/profiles/' + params.id
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROFILE_DETAIL_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROFILE_DETAIL_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROFILE_EDIT] ({dispatch, state, commit}, params) {
      var url = '/asovi/profiles/' + params.id + '/edit'
      var data = {}
      var callback = null
      data = params.data
      if (data) {
        callback = params.callback
      }
      dispatch('apiGet', {url: url, data: data, loadparams: true})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROFILE_EDIT_FAILURE, res.data)
          } else {
            res.data.callback = callback
            commit(PROFILE_EDIT_SUCCESS, res.data)
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROFILE_UPDATE] ({dispatch, state, commit}, params = null) {
      var data = params.data
      var url = '/asovi/profiles/' + params.id
      dispatch('apiPatch', {url: url, data: data})
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROFILE_UPDATE_FAILURE, res.data)
          } else {
            commit(PROFILE_UPDATE_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        throw error
      })
    },
    [PROFILE_IMAGE_UPLOAD] ({dispatch, state, commit}, params) {
      state.uploadSuccess = false
      state.uploadError = false

      dispatch('apiPatch', { url: '/asovi/profiles/profile_image', data: params.data, loadparams: false })
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          if (res.data.error) {
            commit(PROFILE_IMAGE_UPLOAD_FAILURE, res.data)
          } else {
            commit(PROFILE_IMAGE_UPLOAD_SUCCESS, { data: res.data, callback: params.callback })
          }
        }
      })
      .catch(error => {
        state.uploadError = true
        params.errorCallback()
        throw error
      })
    }
  },
  mutations: {
    [PROFILE_DETAIL_FAILURE] (state, data) {
      console.log('PROFILE_DETAIL_FAILURE')
    },
    [PROFILE_DETAIL_SUCCESS] (state, data) {
      console.log('PROFILE_DETAIL_SUCCESS')
      state.profile = data.profile.data[0]
      if (data.callback) {
        data.callback()
      }
    },
    [PROFILE_EDIT_FAILURE] (state, data) {
      console.log('PROFILE_EDIT_FAILURE')
    },
    [PROFILE_EDIT_SUCCESS] (state, data) {
      console.log('PROFILE_EDIT_SUCCESS')
      state.profile = data.profile.data[0]
      if (data.callback) {
        data.callback()
      }
    },
    [PROFILE_UPDATE_FAILURE] (state, data) {
      console.log('PROFILE_UPDATE_FAILURE')
    },
    [PROFILE_UPDATE_SUCCESS] (state, data) {
      console.log('PROFILE_UPDATE_SUCCESS')
      if (data.callback) {
        data.callback()
      }
    },
    [PROFILE_IMAGE_UPLOAD_FAILURE] (state, data) {
      console.log('PROFILE_IMAGE_UPLOAD_FAILURE')
      state.uploadError = true
    },
    [PROFILE_IMAGE_UPLOAD_SUCCESS] (state, data) {
      console.log('PROFILE_IMAGE_UPLOAD_SUCCESS')
      state.uploadSuccess = true
      data.callback(data.data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/profile.js